<template>
  <!--  商品列表-->
  <div
    id="purchaseRelease"
    style="
      width: 100%;
      padding: 0;
      background: #fff;
      min-height: 70vh;
      padding-bottom: 80px;
    "
  >
    <div style="width: 100%; position: relative; left: 0">
      <div class="w100 p_r" style="height: 300px; overflow: hidden">
        <div class="vcenter">
          <img src="../../../../assets/img/bk_img.png" />
        </div>
      </div>
    </div>
    <div class="content_main">
      <div class="search">
        <div style="display: flex">
          <div style="background-color: red; width: 5px"></div>
          <div style="background-color: #f4f4f4; width: 100%; padding: 5px">
            <span style="font-size: 18px; padding: 5px 0 5px 5px">
              完善求购内容
            </span>
            <a
            style="color: brown;"
            @click="() => {
              if (postData.length >= 5) {
                return
              }
              postData.push({
                productName: '',
                originPlace: '',
                material: '',
                spec: ''
              })
            }">
              添加求购内容
            </a>
            <span style="font-size: 13px; color: #a5a5a5"
              >（最多添加5条求购内容）</span
            >
          </div>
        </div>
        <div style="display: flex" v-for="(item, key) of postData"
        :key="key">
          <span style="color: red; margin-top: 20px">*</span>
          <div style="flex: 1">
            <div style="margin-top: 20px">
              <span style="font-size: 16px">品名</span>
              <span style="color: #a5a5a5">（必填项）</span>
            </div>
            <div style="margin-top: 20px">
              <input
                v-model="item.productName"
                type="text"
                placeholder="请输入品名"
                style="padding: 10px; border: #c3c7c6 solid 1px"
              />
            </div>
          </div>
          <div style="flex: 1">
            <div style="margin-top: 20px">
              <span style="font-size: 16px">材质</span>
              <span style="color: #a5a5a5"> （选填项）</span>
            </div>
            <div style="margin-top: 20px">
              <input
                v-model="item.material"
                type="text"
                placeholder="请输入材质"
                style="padding: 10px; border: #c3c7c6 solid 1px"
              />
            </div>
          </div>
          <div style="flex: 1">
            <div style="margin-top: 20px">
              <span style="font-size: 16px">产地</span>
              <span style="color: #a5a5a5">（选填项）</span>
            </div>
            <div style="margin-top: 20px">
              <input
                v-model="item.originPlace"
                type="text"
                placeholder="请输入产地"
                style="padding: 10px; border: #c3c7c6 solid 1px"
              />
            </div>
          </div>
          <div style="flex: 1">
            <div style="margin-top: 20px">
              <span style="font-size: 16px">规格</span>
              <span style="color: #a5a5a5">（选填项）</span>
            </div>
            <div style="margin-top: 20px">
              <input
                v-model="item.spec"
                type="text"
                placeholder="请输入规格"
                style="padding: 10px; border: #c3c7c6 solid 1px"
              />
            </div>
          </div>
          <div style="flex: 1">
            <div style="margin-top: 20px">
              <span style="font-size: 16px">操作</span>
              <span style="color: #a5a5a5"></span>
            </div>
            <div style="margin-top: 20px;padding: 0 12px;">
              <a
              :class="key === 0 ? 'never' : ''"
              @click="() => {
                postData.splice(key, 1)
              }">删除</a>
            </div>
          </div>
        </div>
        <div style="display: flex; margin-top: 20px">
          <div style="background-color: red; width: 5px"></div>
          <div style="background-color: #f4f4f4; width: 100%; padding: 5px">
            <span style="font-size: 18px; padding: 5px 0 5px 5px">
              联系方式
            </span>
            <span style="font-size: 13px; color: #a5a5a5">
              （留下联系方式以便于我们快速给你匹配物资）
            </span>
          </div>
        </div>
        <div style="display: flex">
          <span style="color: red; margin-top: 25px">*</span>
          <div STYLE="flex: 1; margin-top: 20px;">
            <span style="font-size: 16px">联系人</span>
            <input
              v-model="infoData.name"
              type="text"
              placeholder="请输入联系人"
              style="padding: 10px; border: #c3c7c6 solid 1px"
            />
          </div>
          <div STYLE="flex: 1; margin-top: 20px;">
            <span style="color: red; margin-top: 20px">*</span>
            <span style="font-size: 16px">联系电话</span>
            <input
              v-model="infoData.phone"
              type="text"
              placeholder="请输入联系电话"
              style="padding: 10px; border: #c3c7c6 solid 1px"
            />
          </div>
        </div>
        <div style="display: flex; margin-top: 20px">
          <div style="background-color: red; width: 5px"></div>
          <div style="background-color: #f4f4f4; width: 100%; padding: 5px">
            <span style="font-size: 18px; padding: 5px 0 5px 5px">
              其他要求
            </span>
          </div>
        </div>
        <div class="item" style="width: 100%">
          <div class="line text-remark"
          data-max="200"
          :data-length="infoData.specialRequest.length">
            <textarea
              v-model="infoData.specialRequest"
              @input="() => {
                if (infoData.specialRequest.length > 200) {
                  infoData.specialRequest = infoData.specialRequest.substring(0, 200)
                }
              }"
              placeholder="如有其他需求可在此填写，例：特殊规格商品，有无现货等。"
              class="allTextarea"
              style="
                width: calc(100%);
                margin-left: 0;
                height: 150px;
                margin-top: 20px;
              "
            >
            </textarea>
          </div>
        </div>
      </div>

      <!-- button -->
      <div style="width: 100%; text-align: center">
        <button @click="sendRequest" class="butt">发布求购信息</button>
      </div>
    </div>
  </div>
</template>

<script>
import pubilshSet from '../../../../assets/js/pubilshSet'

export default {
  data () {
    return {
      isRegister: window.localStorage.getItem('memberId'),
      postData: [{
        productName: '',
        originPlace: '',
        material: '',
        spec: ''
      }],
      infoData: {
        name: '',
        phone: '',
        specialRequest: ''
      },
      specialRequest: null,
      title: '求购/求购发布',
      cardHeight: 0
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    // 字数
    checkInputLength () {
      let sum = 0
      for (let i = 0; i < this.myList.details.length; i++) {
        var c = this.myList.details.charCodeAt(i)
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
          sum++
        } else {
          sum += 2
        }
      }
      if (sum > 299) {
        this.myList.details = this.myList.details.substring(0, 299)
      }
      this.inputLength = sum
    },
    sendRequest () {
      if (!this.isRegister) {
        window.open(pubilshSet.userCenterHostUrl + 'login')
        return
      }
      // if (this.$commonJs.checkIfEmpty(this.postData, ['productName', 'phone', 'name'])) {
      //   return false
      // }
      for (const item of this.postData) {
        if (!item.productName) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请输入品名',
            stayTime: 5
          })
          return
        }
      }
      if (!this.infoData.name) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请输入联系人',
          stayTime: 5
        })
        return
      }
      if (!this.infoData.phone) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请输入联系电话',
          stayTime: 5
        })
        return
      }
      const contentList = []
      for (const item of this.postData) {
        contentList.push(
          this.$axiox.post('/baigang/shop/helpPurchase/add', {
            ...item,
            ...this.infoData
          })
        )
      }
      Promise.all(contentList).then(() => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '求购内容添加成功',
          stayTime: 5
        })
        this.postData = [{
          productName: '',
          originPlace: '',
          material: '',
          spec: ''
        }]
        this.infoData = {
          name: '',
          phone: '',
          specialRequest: ''
        }
      })
    },
    // 获取list
    getList (e) {
    }
  }
}
</script>

<style scoped>
</style>
<style scoped>
#purchaseRelease .formBox .search {
  padding: 16px 16px 0;
  margin-top: 4px;
  overflow: hidden;
}

#purchaseRelease .formBox .search .item span {
  width: 70px;
  padding-right: 10px;
  text-align: left;
  font-size: 14px;
}
#purchaseRelease .formBox .search .item span input {
  width: 205px;
}
.content_main {
  position: relative;
  width: 70%;
  overflow: hidden;
  box-shadow: 0 0 20px rgb(51 51 51 / 25%);
  padding: 50px 55px;
  margin: auto;
  margin-top: -40px;
  background: #fff;
}
.butt {
  padding: 10px 10% 10px 10%;
  background: red;
  border: none;
  margin-top: 20px;
  font-size: 16px;
  color: #f4f4f4;
  border-radius: 5px;
}
.never {
  pointer-events: none;
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/page/mySteelMall/purchaseRelease.vue